import type { Block } from '../../../../types/proposal-blocks';
import { HeroBlock } from './HeroBlock';
import { NumberedCardsBlock } from './NumberedCardsBlock';
import { SectionBlock } from './SectionBlock';
import { PackagePageBlock } from './PackagePageBlock';
import { ComparisonTableBlock } from './ComparisonTableBlock';
import { MilestonesBlock } from './MilestonesBlock';
import { TableBlock } from './TableBlock';
import { ChartBlock } from './ChartBlock';
import { ImageBlock } from './ImageBlock';
import { ClausesBlock } from './ClausesBlock';
import { CodeBlockBlock } from './CodeBlockBlock';
import { CalloutBlock } from './CalloutBlock';
import { ConditionsBlock } from './ConditionsBlock';

interface BlockRendererProps {
  block: Block;
  onNavigate?: (anchor: string) => void;
  onOpenModal?: () => void;
}

export function BlockRenderer({ block, onNavigate, onOpenModal }: BlockRendererProps) {
  switch (block.type) {
    case 'hero':
      return <HeroBlock block={block} onNavigate={onNavigate} onOpenModal={onOpenModal} />;
    case 'numbered_cards':
      return <NumberedCardsBlock block={block} onNavigate={onNavigate} />;
    case 'section':
      return <SectionBlock block={block} />;
    case 'package_page':
      return <PackagePageBlock block={block} />;
    case 'comparison_table':
      return <ComparisonTableBlock block={block} />;
    case 'milestones':
      return <MilestonesBlock block={block} />;
    case 'table':
      return <TableBlock block={block} />;
    case 'chart':
      return <ChartBlock block={block} />;
    case 'image':
      return <ImageBlock block={block} />;
    case 'clauses':
      return <ClausesBlock block={block} />;
    case 'code_block':
      return <CodeBlockBlock block={block} />;
    case 'callout':
      return <CalloutBlock block={block} />;
    case 'conditions':
      return <ConditionsBlock block={block} />;
    default:
      return null;
  }
}
